import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { LinkNewTabComponent } from '@shared-ui-lib/link-new-tab/link-new-tab.component'

@NgModule({
    declarations: [LinkNewTabComponent],
    exports: [LinkNewTabComponent],
    imports: [CommonModule, MatIconModule],
})
export class LinkNewTabModule {}
